const replyFormStyle = {
  control: {
    backgroundColor: '#fff',
  },
  highlighter: {
    overflow: 'hidden',
  },
  '&multiLine': {
    highlighter: {
      padding: 9,
    },
    input: {
      minHeight: 26,
      fontFamily: '"Gotham A", "Gotham B", "Helvetica Neue", Helvetica, Arial, sans-serif',
      fontSize: '14px',
      appearance: 'none',
      borderRadius: '3px',
      border: '1px solid #57cadc',
      boxShadow: 'none',
      margin: 0,
      outline: 'none',
      padding: '7px 8px',
      transition: 'all .3s ease',
      width: '100%',
      maxWidth: '100%',
      display: 'block',
      boxSizing: 'border-box',
      lineHeight: 'inherit',
    },
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 14,
      },
      item: {
        padding: '5px 15px',
        borderBottom: '1px solid rgba(0,0,0,0.15)',
        '&focused': {
          backgroundColor: 'rgb(207, 245, 253)',
        },
      },
    },
  },
};

const withoutReplyFormStyle = {
  control: {
    backgroundColor: '#fff',
  },
  highlighter: {
    overflow: 'hidden',
  },
  '&multiLine': {
    input: {
      minHeight: 100,
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '5px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',
      '&focused': {
        backgroundColor: 'rgb(207, 245, 253)',
      },
    },
  },
};

export { replyFormStyle, withoutReplyFormStyle };
